export default __webpack_public_path__ + "static/media/Rectangle25.c1034e03.png";